import axios from 'axios';
import Eos from 'eosjs';

// Store modules
import auth from './auth';
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
const AWS = require('aws-sdk')
var CognitoUserPool = AmazonCognitoIdentity.CognitoUserPool;

const BASE_URL = 'https://api.smartpress.co'
// const BASE_URL = 'http://localhost:3000'

// initial state
const state = {
 
  myAccountBalances: {},
  myContractKeys: {},
  transactionStatus: {},
  contractActivity: {},
  newContractStatus: {},
  myAccounts: {},
  myProjectsAccounts: {},
  myContracts: {},
  claimLog: {},
  inviteStatus: {},
  myUsers: {},
  newUserStatus: {},
  user: {},
  myApiKey: {}
}

const getters = { 
}

const mutations = {
  clearData (state) {
    state.myContracts = {},
    state.myAccountBalances = {},
    state.myContractKeys = {},
    state.transactionStatus = {},
    state.contractActivity = {},
    state.userStatus = {},
    state.newContractStatus = {},
    state.myContracts = {}
    state.myAccounts = {},
    state.myProjectsAccounts = {}
  },
  setMyAccounts(state, accounts) {
    console.log(accounts)
    state.myAccounts = accounts
  },
  setMyProjectsAccounts(state, accounts) {
    console.log(accounts)
    state.myProjectsAccounts = accounts
  },
  setMyContracts(state, contracts) {
    console.log(contracts)
    state.myContracts = contracts
  },
  setContractKeys(state, keys) {
    console.log(keys)
    state.myContractKeys = keys
  },
  setApiKey(state, keys) {
    console.log(keys)
    state.myApiKey = keys
  },
  setCurrencyBalance(state, balance) {
    console.log(balance)
    state.myAccountBalances[balance.params.account] = balance
    console.log(state.myAccountBalances)
  },
  txSentTrigger (state) {
    state.transactionStatus = {item: 'sent'}
  },
  setTransactionStatus (state, trx) {
    console.log(trx.data)
    state.transactionStatus = trx
  },
  setMyUsers (state, users) {
    console.log(users)
    state.myUsers = users
  },
  setContractActivity (state, activity) {
    console.log(activity)
    state.contractActivity = activity
  },
  setInviteStatus (state, status) {
    console.log(status)
    state.inviteStatus = status
  },
  setNewContractStatus (state, status) {
    console.log(status)
    state.newContractStatus = status
  },
  setMyContracts (state, contracts) {
    console.log(contracts)
    state.myContracts = contracts
  },
  contractClaimed (state, claimed) {
    console.log(claimed)
    state.claimLog = claimed
  },
  setNewUserStatus(state, user) {
    console.log(user)
    state.newUserStatus
  },
  setUser(state, user) {
    console.log(user)
    state.user
  }
}

const actions = {
  transferToken(context, params) {
    console.log(BASE_URL + '/db/transferToken')
    console.log(params)
     auth.state.getSession.then((token) => {
        console.log(token.accessToken.payload)
        var config = {
            headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                  'accesstoken': token.accessToken.jwtToken}
        };
        return new Promise(function(resolve, reject) {
          axios
            .post(BASE_URL + '/db/transferToken', {
                data: {
                 sender: params.sender,
                 receiver: params.receiver,
                 amount: params.amount,
                 symbol: params.symbol,
                 contract: params.contract,
                 survey_hash: params.survey_hash
                }
              }, config)
            .then(trx => (context.commit('contractsDb/setTransactionStatus', trx, { root: true })))
            .then(resolve(true))
        })
      })
    },
   pushNewContract(context, Params) {

    auth.state.getSession.then((token) => {
      console.log(token.accessToken.payload)
      var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                'accesstoken': token.accessToken.jwtToken}
      };

      axios
        .post(BASE_URL + '/db/newContract', {
            data: {
             ...Params
            }
          }, config)
        // .then(trx => (context.commit('contractsDb/setNewUserStatus', trx.data, { root: true })))
        .then(trx => (context.commit('contractsDb/setNewContractStatus', trx.data, { root: true })))

    })
  },
  createApiKey(context, Params) {

    auth.state.getSession.then((token) => {
      console.log(token.accessToken.payload)
      var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                'accesstoken': token.accessToken.jwtToken}
      };

      axios
        .post(BASE_URL + '/db/createUserApiKey', {
            data: {
             ...Params
            }
          }, config)

    })
  },
  getApiKey(context, Params) {

    auth.state.getSession.then((token) => {
      console.log(token.accessToken.payload)
      var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                'accesstoken': token.accessToken.jwtToken}
      };

      axios
        .post(BASE_URL + '/db/getUserApiKey', {
            data: {}
          }, config)
        // .then(trx => (context.commit('contractsDb/setNewUserStatus', trx.data, { root: true })))
        .then(trx => (context.commit('contractsDb/setApiKey', trx.data, { root: true })))

    })
  },
  getMyContracts(context, Params) {
    console.log('hi')
    auth.state.getSession.then((token) => {

      if (!token.accessToken) {
        // location.reload();
        return null
      }
      console.log(token.accessToken.payload)

      var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                'accesstoken': token.accessToken.jwtToken}
      };

      axios
        .post(BASE_URL + '/db/getMyContracts', {
            data: {
            }
          }, config)
        .then(trx => (context.commit('contractsDb/setMyContracts', trx.data, { root: true })))
    })
  },
  getMyAccounts(context, Params) {
    console.log('hi')
    auth.state.getSession.then((token) => {

      if (!token.accessToken) {
        location.reload();
      }
      console.log(token.accessToken.payload)

      var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                'accesstoken': token.accessToken.jwtToken}
      };

      axios
        .post(BASE_URL + '/db/getMyAccounts', {
            data: {
            }
          }, config)
        .then(trx => (context.commit('contractsDb/setMyAccounts', trx.data, { root: true })))
    })
  },
  getMyProjectsAccounts(context, Params) {
    console.log('hi')
    auth.state.getSession.then((token) => {

      if (!token.accessToken) {
        location.reload();
      }
      console.log(token.accessToken.payload)

      var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                'accesstoken': token.accessToken.jwtToken}
      };

      axios
        .post(BASE_URL + '/db/getMyProjectsAccounts', {
            data: {
            }
          }, config)
        .then(trx => (context.commit('contractsDb/setMyProjectsAccounts', trx.data, { root: true })))
    })
  },
  accountClaimed(context, Params) {
    console.log('hi')
    auth.state.getSession.then((token) => {
      console.log(token.accessToken.payload)
      var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                'accesstoken': token.accessToken.jwtToken}
      };

      axios
        .post(BASE_URL + '/db/accountClaim', {
            data: {
              ...Params
            }
          }, config)
        .then(trx => (context.commit('contractsDb/setMyAccounts', trx.data, { root: true })))
    })
  },
  contractClaimed(context, Params) {
    console.log('hi')
    auth.state.getSession.then((token) => {
      console.log(token.accessToken.payload)
      var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                'accesstoken': token.accessToken.jwtToken}
      };

      axios
        .post(BASE_URL + '/db/accountClaim', {
            data: {
              ...Params
            }
          }, config)
        .then(trx => (context.commit('contractsDb/setMyContracts', trx.data, { root: true })))
    })
  },
  email(context, Params) {
    console.log('hi')
    auth.state.getSession.then((token) => {
    console.log(token.accessToken.payload)
    var config = {
        headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
              'accesstoken': token.accessToken.jwtToken}
    };

    axios
      .post(BASE_URL + '/db/projectInvite', {
        data: {
            ...Params
          }
        }, config)
      .then(trx => (context.commit('contractsDb/setInviteStatus', trx.data, { root: true })))
    })
  },
  getMyUsers(context, Params) {
    console.log('hi')
    auth.state.getSession.then((token) => {
    console.log(token.accessToken.payload)
    var config = {
        headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
              'accesstoken': token.accessToken.jwtToken}
    };

    axios
      .post(BASE_URL + '/db/myUsers', {
        data: {
            
          }
        }, config)
      .then(trx => (context.commit('contractsDb/setMyUsers', trx.data, { root: true })))
    })
  },
  getUser(context, Params) {
    console.log('hi')
    auth.state.getSession.then((token, err) => {
      var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                'accesstoken': token.accessToken.jwtToken}
      }

      axios
        .post(BASE_URL + '/db/getUser', {
          data: {
              
            }
          }, config)
        .then(trx => (context.commit('contractsDb/setUser', trx.data, { root: true })))
      })
  },
  getUser(context, Params) {
    console.log('hi')
    auth.state.getSession.then((token, err) => {
      var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                'accesstoken': token.accessToken.jwtToken}
      }

      axios
        .post(BASE_URL + '/db/getUser', {
          data: {
              ...Params
            }
          }, config)
        .then(trx => (context.commit('contractsDb/setNewUserStatus', trx.data, { root: true })))
      })
  },
  getCurrencyBalances(context, Params) {
    console.log('getting data')
     auth.state.getSession.then((token) => {
      console.log(token.accessToken.payload)
      var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                'accesstoken': token.accessToken.jwtToken}
      };

      console.log(config)
      axios
        .post(BASE_URL + '/db/getCurrencyBalance', {
            data: {
              ...Params
            }
          }, config)
        .then(balance => (context.commit('contractsDb/setCurrencyBalance', balance.data, { root: true })))
    })
  },
  getContractActivity(context, Params) {
    console.log('getting data')
    auth.state.getSession.then((token) => {
      console.log(token.accessToken.payload)
      var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                'accesstoken': token.accessToken.jwtToken}
      };

      console.log(config)
      axios
        .post(BASE_URL + '/db/getContractActivity', {
            data: {
              ...Params
            }
          }, config)
        .then(balance => (context.commit('contractsDb/setContractActivity', balance.data, { root: true })))
    })
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// To be merged when the feature ships

  // getCurrencyBalances(context) {
  //   console.log('getting data')
  //    auth.state.getSession.then((token) => {
  //       console.log(token.accessToken.payload)
  //       var config = {
  //           headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
  //                 'accesstoken': token.accessToken.jwtToken}
  //       };

  //       console.log(config)
  //       axios
  //         .post(BASE_URL + '/db/getCurrencyBalance', {
  //             data: {
  //              user_id:'admin',
  //              contract:'smartpress11',
  //              symbol:'NEWER'
  //             }
  //           }, config)
  //         .then(balance => (context.commit('contractsDb/setCurrencyBalance', balance.data, { root: true })))
  //     })
  //   },

  // transferToken(context, params) {
  //   console.log('getting data')
  //   console.log(params)
  //    auth.state.getSession.then((token) => {
  //       console.log(token.accessToken.payload)
  //       var config = {
  //           headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
  //                 'accesstoken': token.accessToken.jwtToken}
  //       };
  //       axios
  //         .post('http://ec2-18-224-0-247.us-east-2.compute.amazonaws.com/db/transferToken', {
  //             data: {
  //              sender: params.sender,
  //              receiver: params.receiver,
  //              contract:'eosio.token',
  //              amount: params.amount,
  //              symbol: params.symbol,
  //              survey_hash: params.survey_hash
  //             }
  //           }, config)
  //         .then(trx => (context.commit('contractsDb/setTransactionStatus', trx, { root: true })))
  //     })
  //   },
  // issueToken(context) {
  //   console.log('getting data')
  //    auth.state.getSession.then((token) => {
  //       console.log(token)
  //       var config = {
  //           headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
  //                 'accesstoken': token.accessToken.jwtToken}
  //       };

  //       axios
  //         .post(BASE_URL + '/db/issueToken', {
  //             data: {
  //              receiver:'smartpress11',
  //              contract:'smartpress11',
  //              amount: '1',
  //              symbol:'LACH'
  //             }
  //           }, config)
  //         .then(trx => (context.commit('contractsDb/setTransactionStatus', trx.data, { root: true })))
  //     })
  //   },
  // createToken(context) {
  //   console.log('getting data')
  //    auth.state.getSession.then((token) => {
  //       console.log(token.accessToken.payload)
  //       var config = {
  //           headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
  //                 'accesstoken': token.accessToken.jwtToken}
  //       };

  //       axios
  //         .post(BASE_URL + '/db/createToken', {
  //             data: {
  //              contract:'smartpress11',
  //              amount: '1000',
  //              symbol:'LACHIE'
  //             }
  //           }, config)
  //         .then(trx => (context.commit('contractsDb/setTransactionStatus', trx.data, { root: true })))
  //     })
  //   },